// ignore-string-externalization

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { ThemeProvider } from 'styled-components';
import { loadMe, selectMe } from '../shared/store/me';
import ScrollToTop from '../shared/components/ScrollToTop';
import PageHead from '../shared/components/PageHead';
import { NavBar } from '../../features/Layout/Nav';
import { UserState } from '../../features/Layout/Nav/types';
import { Footer as FrodorFooter } from '../../features/Layout/Footer';
import { LayoutState } from '../../features/Layout';
import { darkTheme } from '../../features/Theme';
import { Track } from '../../features/Tracking';
import Layout from './Layout';

type Props = {
  loadMe: () => void;
  location: {
    pathname: string;
    search: string;
  };
  me?: {
    isEmployee?: boolean;
    hasAccess?: boolean;
    username?: string;
    features?: $TSFixMe;
    partnerIds?: {
      google?: string;
    };
  };
  children?: React.ReactNode;
  forceState?: UserState;
  defaultMenuState?: {
    help?: boolean;
    resources?: boolean;
    side?: boolean;
  };
  history?: {
    push?: () => void;
  };
};

class Root extends Component<Props> {
  componentDidMount() {
    this.props.loadMe();
  }

  render() {
    const isPlain =
      /\.plain$/.test(this.props.location.pathname) ||
      /plain/.test(this.props.location.search);

    const NavComponent = () => {
      return (
        <LayoutState>
          <ThemeProvider theme={darkTheme}>
            <NavBar
              forceState={this.props.forceState}
              defaultMenuState={this.props.defaultMenuState}
            />
          </ThemeProvider>
        </LayoutState>
      );
      // legacy nav: <Navigation me={this.props.me} />
    };

    return (
      <>
        <PageHead />
        <ScrollToTop>
          <Track>
            <Layout
              navigation={!isPlain && <NavComponent />}
              content={this.props.children}
              footer={
                !isPlain && (
                  <ThemeProvider theme={darkTheme}>
                    <FrodorFooter />
                  </ThemeProvider>
                )
              }
            />
          </Track>
        </ScrollToTop>
      </>
    );
  }
}

const selector = createStructuredSelector({ me: selectMe });

const actions = { loadMe };

export default connect(selector, actions)(Root as $TSFixMe);
